module.exports = __webpack_public_path__ + "static/eji-ae44d7e86bcad7fdf30e92d6072c77c6.png";